import { render } from "./PaymentBalance.vue?vue&type=template&id=398499aa&scoped=true"
import script from "./PaymentBalance.vue?vue&type=script&lang=js"
export * from "./PaymentBalance.vue?vue&type=script&lang=js"

import "./PaymentBalance.vue?vue&type=style&index=0&id=398499aa&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398499aa"]])

export default __exports__